import * as React from 'react';

import {Chevron} from '../chevron';

import styles from './empty-stages-graphic.module.css';

export function EmptyStagesGraphic() {
    return (
        <div className={styles['stages-empty-graphic']}>
            <div className={styles['stages-empty-chevron-container']}>
                {[0, 1, 2, 3].map((num: number) => {
                    return (
                        <Chevron
                            key={num}
                            hasStraightLeft={num === 0}
                            style={{
                                marginRight: 16,
                                flexGrow: 1,
                                backgroundColor: '#F7F7F7',
                                height: 50,
                                width: 240,
                            }}
                        />
                    );
                })}
            </div>
            <div className={styles['stages-empty-graphic-text']}>
                No stages defined for this pipeline
            </div>
        </div>
    );
}
